"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDateByTimeZoneStrict = exports.convertDateByTimeZone = void 0;
const constants_1 = require("@pulse-web-platform-core/constants");
const date_fns_tz_1 = require("date-fns-tz");
const convertDateByTimeZone = (date, timeZone) => {
    return date instanceof Date
        ? (0, exports.convertDateByTimeZoneStrict)(date, timeZone)
        : date;
};
exports.convertDateByTimeZone = convertDateByTimeZone;
const convertDateByTimeZoneStrict = (date, timeZone) => {
    return (0, date_fns_tz_1.utcToZonedTime)(date, timeZone || constants_1.TIME_ZONE_MOSCOW);
};
exports.convertDateByTimeZoneStrict = convertDateByTimeZoneStrict;
